// @flow

import React from "react";
import RCTooltip from "rc-tooltip";
import classNames from "classnames";

import "./tooltip.css";

export const Tooltip = ({ overlayClassName, ...props }: *) => (
  <RCTooltip
    overlayClassName={classNames("MedidaSelecionadasTooltip", overlayClassName)}
    {...props}
  />
);

export const WithTooltip = ({ enabled, children, ...props }: *) =>
  enabled ? <Tooltip {...props}>{children}</Tooltip> : children;
